import { useEffect, useState } from 'react';
import AccordianDownIcon from '../../assets/AccordianDownIcon';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import AddFormIcon from '../../assets/AddFormIcon';
import AddFormIconDark from '../../assets/AddFormIconDark';
import Accordion from '../../components/common/Accordian';
import useBgColorStore from '../../store/bgColor';
import DriverForm from './DriverForm';
import Loader from '../../assets/loader/Loader';
import DriverDetailsCard from './DriverCard';
import { translate } from '../../i18n';
import { IStaffAllocation } from '../../type/staffAllocation';
import useLocationStore from '../../store/locatonStore';
import { IRouteDetails } from '../../type/routeDetails';
import { IBusDetails } from '../../type/busDetails';
import { IBalloonDetails } from '../../type/balloonDetails';
import { useStaffAllocation } from '../../hooks/apiHook/operationDetails';

type ModalType =
  | 'CrewForm'
  | 'DriverForm'
  | 'PilotForm'
  | 'EditFormFlight'
  | 'GeneralComment'
  | null;

interface DriverFormProps {
  routes: IRouteDetails[];
  buses: IBusDetails[];
  balloons: IBalloonDetails[];
  date: Date;
}

export default function DriverComponent({
  routes,
  buses,
  balloons,
  date,
}: DriverFormProps) {
  const [crewDetails, setCrewDetails] = useState<IStaffAllocation | null>(null);
  const [operationStaffId, setOperationStaffId] = useState<number>();
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const [driverAccordionIsOpen, setDriverAccordionIsOpen] = useState<
    boolean | undefined
  >(false);
  const { bgColor } = useBgColorStore();
  const handleStaffChange = (type: 'driver' | 'pilot' | 'crew' | 'booking') => {
    if (type === 'driver') {
      setDriverAccordionIsOpen(true);
      refetch();
    }
  };
  const closeModal = () => setActiveModal(null);
  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const handleOperationStaffIdChange = (operationStaffId: number) => {
    setOperationStaffId(operationStaffId);
  };
  const openModal = (modalType: ModalType, staff?: IStaffAllocation) => {
    setActiveModal(modalType);
    setCrewDetails(staff ?? null);
  };
  const [staffAllocation, setStaffAllocation] = useState<IStaffAllocation[]>();

  const {
    data: staffAllocationData,
    isLoading,
    isFetching,
    refetch,
  } = useStaffAllocation(selectedLocation.OwnerId, date);

  // Sync to local state
  useEffect(() => {
    if (staffAllocationData) {
      setStaffAllocation(staffAllocationData);
    }
  }, [staffAllocationData, isFetching]);

  return (
    <>
      <Accordion
        title="Drivers Allocation"
        bgColor={`${bgColor}`}
        iconOpen={
          <div>
            <div className="block dark:hidden">
              <AccordianDownIcon />
            </div>
            <div className="hidden dark:block">
              <AccordianDownIconDark />
            </div>
          </div>
        }
        iconClose={
          <div>
            <div className="block dark:hidden">
              <AccordianUpIcon />
            </div>
            <div className="hidden dark:block">
              <AccordianUpIconDark />
            </div>
          </div>
        }
        icon={
          <div>
            <div className="block dark:hidden">
              <AddFormIcon />
            </div>
            <div className="hidden dark:block">
              <AddFormIconDark />
            </div>
          </div>
        }
        accordionIsOpen={driverAccordionIsOpen}
        toggleState={setDriverAccordionIsOpen}
        formComponent={
          <DriverForm
            routes={routes || []}
            buses={buses || []}
            balloons={balloons || []}
            heading="Add Driver"
            closeModal={closeModal}
            onStaffChange={() => handleStaffChange('driver')}
            staffAllocation={staffAllocation || null}
            date={date}
          />
        }
      >
        {isLoading || isFetching ? (
          <div className="flex justify-center align-middle">
            <Loader />
          </div>
        ) : staffAllocation && staffAllocation.length > 0 ? (
          <DriverDetailsCard
            updateDriverListOperations={staffAllocation}
            openModal={openModal}
            onOperationStaffIdChange={handleOperationStaffIdChange}
            onStaffChange={() => handleStaffChange('driver')}
          />
        ) : (
          <div className="text-center text-textColorGray p-4">
            {translate('operation.dataIsNotAvailable')}
          </div>
        )}
        {activeModal === 'DriverForm' && crewDetails && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-2">
            <DriverForm
              routes={routes || []}
              buses={buses || []}
              balloons={balloons || []}
              updateDriverListOperations={
                activeModal === 'DriverForm' ? staffAllocation : undefined
              }
              heading="Edit Driver Details"
              closeModal={closeModal}
              operationStaffId={operationStaffId}
              initialValues={crewDetails}
              onStaffChange={() => handleStaffChange('driver')}
              staffAllocation={staffAllocation || null}
              date={date}
            />
          </div>
        )}
      </Accordion>
    </>
  );
}
